import { render, staticRenderFns } from "./sjfx.vue?vue&type=template&id=7bf638f7&scoped=true&"
import script from "./sjfx.vue?vue&type=script&lang=js&"
export * from "./sjfx.vue?vue&type=script&lang=js&"
import style0 from "./sjfx.vue?vue&type=style&index=0&id=7bf638f7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bf638f7",
  null
  
)

export default component.exports